import { render, staticRenderFns } from "./DialogCompetition.vue?vue&type=template&id=60e56a2b&"
import script from "./DialogCompetition.vue?vue&type=script&lang=js&"
export * from "./DialogCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports